module.exports = __webpack_public_path__ + "static/carbon-tooltip-7403359d9e5c411aba2c1d9e0b9e9876.png";